import React from 'react';
import { observer } from 'mobx-react';

import TextField from 'app/commonComponents/TextField';
import { Label } from 'modules/tickets/components/common/dialog/TicketFormUtils';
import form from 'modules/ticketPublicPage/stores/vouchers/form';
import { Container, InlineForm } from './styles/_contactDetails';
import { textFieldLabelStyle } from './Initial';

const ContactDetails = observer(() => {
  const { formValues, errors, setFormValue, validateField } = form;

  return (
    <Container>
      <div>
        {i18n.gettext(
          'Please enter the following information so we can assign the voucher'
        )}
      </div>
      <Label style={{ fontSize: 'inherit', marginBottom: 0 }}>
        {i18n.gettext('Recipient of voucher:')}
      </Label>
      <InlineForm>
        <TextField
          label={i18n.gettext('First Name')}
          required
          placeHolder={i18n.gettext('e.g. John')}
          onChange={(e) => setFormValue('recipient_name', e.target.value)}
          onBlur={() => validateField('recipient_name')}
          value={formValues.get('recipient_name')}
          error={errors.get('recipient_name')}
          style={{ marginBottom: 0 }}
          labelStyle={textFieldLabelStyle}
        />
        <TextField
          label={i18n.gettext('Last name')}
          required
          placeHolder={i18n.gettext('e.g. Smith')}
          onChange={(e) => setFormValue('recipient_surname', e.target.value)}
          onBlur={() => validateField('recipient_surname')}
          value={formValues.get('recipient_surname')}
          error={errors.get('recipient_surname')}
          style={{ marginBottom: 0 }}
          labelStyle={textFieldLabelStyle}
        />
      </InlineForm>
      <Label style={{ fontSize: 'inherit', margin: '1rem 0 0 0' }}>
        {i18n.gettext('Your Details:')}
      </Label>
      <InlineForm>
        <TextField
          label={i18n.gettext('First Name')}
          required
          placeHolder={i18n.gettext('e.g. John')}
          onChange={(e) => setFormValue('name', e.target.value)}
          onBlur={() => validateField('name')}
          value={formValues.get('name')}
          error={errors.get('name')}
          style={{ marginBottom: 0 }}
          labelStyle={textFieldLabelStyle}
        />
        <TextField
          label={i18n.gettext('Last name')}
          required
          placeHolder={i18n.gettext('e.g. Smith')}
          onChange={(e) => setFormValue('surname', e.target.value)}
          onBlur={() => validateField('surname')}
          value={formValues.get('surname')}
          error={errors.get('surname')}
          style={{ marginBottom: 0 }}
          labelStyle={textFieldLabelStyle}
        />
      </InlineForm>
      <TextField
        label={i18n.gettext('Email')}
        required
        placeHolder={i18n.gettext('e.g. example@email.com')}
        onChange={(e) => setFormValue('email', e.target.value)}
        onBlur={() => validateField('email')}
        value={formValues.get('email')}
        error={errors.get('email')}
        style={{ width: '100%', marginBottom: 0 }}
        labelStyle={textFieldLabelStyle}
      />
    </Container>
  );
});

export default ContactDetails;
